<template>
  <div class="bit-breaker" id="million-bit-breaker">
    <div id="game-menu">
        <div>
            <span class="btn-group nav-buttons">
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="navigateTo('/')"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-house"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"></path></svg></button>
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="mute(true)" v-if="!isMuted">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-up-fill" viewBox="0 0 16 16">
                    <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/>
                    <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/>
                    <path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/>
                </svg>
            </button>
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="mute(false)" v-if="isMuted">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-mute-fill" viewBox="0 0 16 16">
                    <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/>
                </svg>
            </button>
            <!-- <button class="btn btn-outline-light" v-on:click="newGame();">New Game</button> -->
            </span>
        </div>
        <div><h1 class="honk-text">Million Bit Break</h1></div>
        <div><h3><span id="score-label">Score</span> <span class="honk-text" v-text="score"></span></h3></div>
    </div>
    <div id="game-frame">
        <canvas id="gameCanvas" width="1024" height="1024"></canvas>

        <div id="game-over" v-if="!isPlaying">
            <h1>Your Score <span class="honk-text" v-text="score"></span></h1>
            <h1>High Score <span class="honk-text" v-text="highscore"></span></h1>
            <a v-bind:href="xPost" target="_blank" class="btn btn-block btn-lg btn-outline-light" v-if="score > 0">Share on X</a>
            <button class="btn btn-block btn-lg btn-warning my-5" v-on:click="newGame();">New Game</button>
            <div id="game-leaderboard" class="mt-4">
                <h3 style="text-decoration: underline;">Leaderboard</h3>
                <p v-if="!appData().connectedAccount.address">Join the leaderboard by first connecting your wallet! <br />
                    <button type="button" class="btn btn-icon btn-block btn-info mt-5" v-on:click="connectWallet()">
                        Connect Wallet
                    </button>
                </p>
                <div class="btn-group btn-block">
                    <button type="button" class="btn btn-icon btn-block btn-outline-light my-3" v-on:click="toggleLeaderBoard()" v-bind:class="{'disabled': this.leaderBoardToggle === 'all'}">
                        This Week
                    </button>
                    <button type="button" class="btn btn-icon btn-block btn-outline-light my-3" v-on:click="toggleLeaderBoard()" v-bind:class="{'disabled': this.leaderBoardToggle === 'week'}">
                        All Time
                    </button>
                </div>
                <p v-if="appData().connectedAccount.address">
                    Player: 
                    <img v-if="appData().connectedAccount.avatar" v-bind:src="appData().connectedAccount.avatar" style="max-height: 22px;" class="ensAvatar">
                    <span v-if="appData().connectedAccount.name">{{ appData().connectedAccount.name }}</span>
                    <span v-if="!appData().connectedAccount.name">{{ appData().connectedAccount.addressTrunc }}</span>
                </p>
                <table style="width: 100%">
                    <tr>
                        <th class="text-left"> </th>
                        <th class="text-left">Player</th>
                        <th class="text-right">Score</th>
                    </tr>
                    <tr v-if="gameLeaderboard.length === 0">
                        <td colspan="3" class="text-center">Loading...</td>
                    </tr>
                    <tr v-for="(entry, index) in gameLeaderboard" v-bind:key="entry._id">
                        <td><h5 class="mr-1 honk-text">{{ index + 1 }}</h5></td>
                        <td class="text-left">
                            <span v-if="entry.player.avatar">
                                <img v-bind:src="entry.player.avatar" style="max-height: 22px;" class="ensAvatar">
                            </span>
                            <span v-if="entry.player.name">{{ entry.player.name }}</span>
                            <span v-if="!entry.player.name && entry.player.addressTrunc">{{ entry.player.addressTrunc }}</span>
                            <span v-if="!entry.player.name && !entry.player.addressTrunc">Anon</span>
                        </td>
                        <td class="text-right">
                            <h4 class="mr-1 honk-text"><span v-if="entry.didWin" class="pr-2">🏆</span>{{ entry.score }}</h4>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import utils from '../utils'
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
const LOCAL_STORAKE_BREAK_HIGHSCORE_KEY = 'break_highscore';
const LOCAL_STORAGE_BREAK_MUTE_KEY = 'break_muted';
const sfx = {
    bounce: new Audio('/static/bounce.mp3'),
    gameover: new Audio('/static/gameover.mp3'),
    gamestart: new Audio('/static/gamestart.mp3'),
    gamewin: new Audio('/static/gamewin.mp3'),
};

export default {
  name: 'classic',
  data () {
    return {
      isMuted: false,
      gameLeaderboard: [],
      leaderBoardToggle: 'week',
      s3Base: BASE_S3_BUCKET,
      s3ImgSrc: BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      score: 0,
      highscore: localStorage.getItem(LOCAL_STORAKE_BREAK_HIGHSCORE_KEY) || 0,
      isPlaying: false,
      // User Paddle
      speed: 0, // Starting speed
      acceleration: 0.5, // Speed increment over time
      maxSpeed: 10, // Maximum speed limit
      movementInterval: null, // To store the interval ID for movement
      movingLeft: false,
      movingRight: false,
      linkMap: []
    }
  },
  computed: {
    xPost: function() {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent('🕹️ I just scored ' + this.score + ' on Million Bit Break! Can you beat my score?')}&url=${encodeURIComponent('https://millionbithomepage.com/break')}`;
    },
  },
  methods: {
    newGame: function() {
      this.playGame();
        this.playSound('gamestart');
    },
    mute: function(doMute) {
      this.isMuted = doMute;
      localStorage.setItem(LOCAL_STORAGE_BREAK_MUTE_KEY, this.isMuted);
    },
    toggleLeaderBoard: function() {
        if (this.leaderBoardToggle === 'all') {
            this.leaderBoardToggle = 'week';
        } else {
            this.leaderBoardToggle = 'all';
        }
        this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
    },
    playSound: function(sound) {
        if (this.isMuted) {
            return;
        }
        sfx[sound].currentTime = 0;
        sfx[sound].play();
    },
    saveScore: async function(score, didWin) {
        const player = this.appData().connectedAccount;
        await this.postToLambda('recordBreakScore', {
            score: score,
            player: player,
            didWin: didWin,
        });
    },
    endGame: async function(didWin) {
        if (this.isPlaying) {
            this.isPlaying = false;
            if (didWin) {
                this.playSound('gamewin');
                utils.confetti(12000);
            } else {
                this.playSound('gameover');
            }
            if (this.score) {
                await this.saveScore(this.score, didWin);
                utils.trackEvent(`breakScore:${this.score}`);
                if (this.score > this.highscore) {
                    this.highscore = this.score;
                    localStorage.setItem(LOCAL_STORAKE_BREAK_HIGHSCORE_KEY, this.highscore);
                }
            }
            await this.loadLeaderboard();
        }
    },
    loadLeaderboard: async function() {
        this.gameLeaderboards = await this.postToLambda('getBreakLeaderboard', {});
        this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
    },
    playGame: async function() {
        let self = this;
      utils.trackEvent(`playGame:break`);
      this.isPlaying = true;
      this.score = 0;

      // Canvas setup
const canvas = document.getElementById('gameCanvas');
this.canvas = canvas;
const ctx = canvas.getContext('2d');

// Game objects
let ball, paddle, bricks;

// Background image object
let backgroundImage = new Image();
backgroundImage.src = 'https://millionbithomepage.com/static/billboard/homepage.jpeg'; // Replace with your image path

// SVG markup
const svgMarkup = `
<svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Z" fill="#1B53E4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 28c0 11.598 9.402 21 21 21s21-9.402 21-21S39.598 7 28 7 7 16.402 7 28Zm17.234-6.766a3 3 0 0 0-3 3v7.533a3 3 0 0 0 3 3h7.533a3 3 0 0 0 3-3v-7.533a3 3 0 0 0-3-3h-7.533Z" fill="#fff"/>
</svg>`;

// Convert SVG to data URL
const svgDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgMarkup);

// Create an image object
const paddleImg = new Image();
paddleImg.src = svgDataUrl;

// Set canvas size and initialize game objects
function initGame() {
    setCanvasSize();
    initGameObjects();
}

function setCanvasSize() {
    const maxWidth = Math.min(1024, window.innerWidth);
    const maxHeight = window.innerHeight - 60;
    const aspectRatioW = 3;
    const aspectRatioH = 4;
    if (maxWidth / aspectRatioW * aspectRatioH <= maxHeight) {
        // If we can fit 3:4 aspect ratio, use it
        canvas.width = maxWidth;
        canvas.height = maxWidth / aspectRatioW * aspectRatioH;
    } else {
        // Otherwise, use the max height and calculate width
        canvas.height = maxHeight;
        canvas.width = maxHeight / aspectRatioH * aspectRatioW;
    }
    
    // Ensure width doesn't exceed maxWidth
    canvas.width = Math.min(canvas.width, maxWidth);
}

function initGameObjects() {
    // Initialize ball
    ball = {
        // Start at random position between 1/3 and 2/3 of canvas width
        x: canvas.width / 3 + Math.random() * canvas.width / 3,
        // x: canvas.width / 1.5,
        y: canvas.height - (canvas.height * 0.1) - 10,
        dx: 3, //2,
        dy: -3, //-2,
        radius: canvas.width * 0.01
    };

    // Initialize paddle
    paddle = {
        width: canvas.width * 0.15,
        height: canvas.height * 0.03,
        x: (canvas.width - canvas.width * 0.15) / 2,
        y: canvas.height - canvas.height * 0.1
    };
    self.paddle = paddle;

    // Initialize bricks
    initBricks();
}

const initBricks = () => {
    bricks = [];

    const scale = canvas.width / 1024;

    // For each entry in this.linkMap, create a brick
    this.linkMap.forEach((link) => {
        let [x1, y1, x2, y2] = link.c.split(',');
        let x0 = parseInt(x1);
        let y0 = parseInt(y1);
        x1 = parseInt(x1) * scale;
        y1 = parseInt(y1) * scale;
        x2 = parseInt(x2) * scale;
        y2 = parseInt(y2) * scale;

        bricks.push({
            x0: x0,
            y0: y0,
            x: x1,
            y: y1,
            width: x2 - x1 + 1,
            height: y2 - y1 + 1,
            status: 1,
            // url: link.u
        });
    });
}

// Call initGame on load and resize
initGame();
window.addEventListener('resize', () => {
    this.endGame();
    initGame();
});

// Event listeners for mouse and touch
canvas.addEventListener('mousemove', moveHandler);
canvas.addEventListener('touchmove', moveHandler);

function moveHandler(e) {
    let relativeX;
    if (e.type === 'mousemove') {
        relativeX = e.clientX - canvas.offsetLeft;
    } else if (e.type === 'touchmove') {
        e.preventDefault(); // Prevent scrolling when touching the canvas
        relativeX = e.touches[0].clientX - canvas.offsetLeft;
    }
    
    if (relativeX > 0 && relativeX < canvas.width) {
        paddle.x = relativeX - paddle.width / 2;
    }
}

// Drawing functions
function drawBackground() {
    ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.width);
}

// Drawing functions
function drawBall() {
    ctx.drawImage(paddleImg, ball.x, ball.y, ball.radius * 2, ball.radius * 2);
}

function drawPaddle() {
    ctx.beginPath();
    ctx.rect(paddle.x, paddle.y, paddle.width, paddle.height);
    ctx.fillStyle = '#000';
    ctx.fill();
    ctx.closePath();
}

const drawBricks = () => {
    // For each brick, draw it
    let hasBricks = false;
    bricks.forEach((brick) => {
        if (brick.status === 0) {
            ctx.beginPath();
            ctx.rect(brick.x, brick.y, brick.width, brick.height);

            // fill color should be a checkboard pattern every 16px square between white and #ccc
            const fillColor = (Math.floor(brick.x0 / 16) + Math.floor(brick.y0 / 16)) % 2 === 0 ? '#ccc' : '#fff';
            // const fillColor = 
            ctx.fillStyle = fillColor; //'#0095DD';
            ctx.fill();
            ctx.closePath();
        } else {
            hasBricks = true;
        }
    });
    if (!hasBricks) {
        this.endGame(true);
    }
}

const hitBrick = (brick) => {
    brick.status = 0;
    this.score += 16;
    ballBounce();
}

// Collision detection
const isColliding = (ball, brick) => {
    return ball.x < brick.x + brick.width &&
           ball.x + ball.radius * 2 > brick.x &&
           ball.y < brick.y + brick.height &&
           ball.y + ball.radius * 2 > brick.y;
};

const collisionDetection = () => {
    let horizontalCollision = false; // To track if horizontal velocity (dx) should flip
    let verticalCollision = false;   // To track if vertical velocity (dy) should flip

    bricks.forEach((brick) => {
        if (brick.status === 1 && isColliding(ball, brick)) {
            // Determine collision side by comparing ball's center to brick's center
            const ballCenterX = ball.x + ball.radius;
            const ballCenterY = ball.y + ball.radius;
            const brickCenterX = brick.x + brick.width / 2;
            const brickCenterY = brick.y + brick.height / 2;

            const distX = ballCenterX - brickCenterX;
            const distY = ballCenterY - brickCenterY;

            // Prioritize the axis with the larger absolute distance
            if (Math.abs(distX) > Math.abs(distY)) {
                // Horizontal collision
                if (!horizontalCollision) {
                    ball.dx = -ball.dx; // Reflect ball's horizontal direction
                    horizontalCollision = true;
                }
            } else {
                // Vertical collision
                if (!verticalCollision) {
                    ball.dy = -ball.dy; // Reflect ball's vertical direction
                    verticalCollision = true;
                }
            }

            hitBrick(brick); // Remove or handle brick hit
        }
    });
};


const ballBounce = () => {
    this.playSound('bounce');
}

// Main game loop
let lastTime = performance.now();
const draw = () => {
    const timestamp = performance.now();
    if (!lastTime) lastTime = timestamp;
    let deltaTime = (timestamp - lastTime) / 10; // Convert to seconds
    lastTime = timestamp;

    const ballDx = ball.dx * deltaTime;
    const ballDy = ball.dy * deltaTime;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawBackground();
    drawBricks();
    drawBall();
    drawPaddle();
    collisionDetection();

    const ballCenterX = ball.x + ball.radius;

    // Ball movement and collision with walls
    if (ball.x + ballDx > canvas.width - (ball.radius*2)) {
        ball.dx = -ball.dx;
        ball.x = canvas.width - (ball.radius*2);
        ballBounce();
    } else if (ball.x + ballDx < 0) {
        ball.dx = -ball.dx;
        ball.x = 0;
        ballBounce();
    }
    if (ball.y + ballDy < ball.radius) {
        ball.dy = -ball.dy;

        // Move the ball to the top of the canvas to prevent glitches
        ball.y = ball.radius;
        ballBounce();
    } else if (ball.dy > 0 && ball.y + ballDy + (ball.radius * 2) > paddle.y) {
        if (ballCenterX > paddle.x && ballCenterX < paddle.x + paddle.width) {
            
            // Ball hit the paddle
            // Reflect the ball based on where it hit the paddle
            ball.dx = 8 * ((ballCenterX - paddle.x) / paddle.width - 0.5);
            ball.dy = -ball.dy;

            // Move the ball to the top of the paddle to prevent glitches
            ball.y = paddle.y - ball.radius;

            // Shrink the paddle unless it's reached a minimum size
            if (paddle.width > canvas.width * 0.05) {
                paddle.width *= 0.99;
                paddle.x += (paddle.width * 0.05) / 2;
            }
            ballBounce();
            // Increase ball speed when it hits the paddle
            // ball.dx *= 1.05;
            // ball.dy *= 1.05;
        } else {
            ball.dx = 0;
            ball.dy = 0;
            this.endGame();
        }
    }

    // Move the ball
    ball.x += ballDx;
    ball.y += ballDy;

    if (this.isPlaying) {
        requestAnimationFrame(draw);
    }
}

    try {
        await this.ensureImageLoaded(backgroundImage);
        await this.ensureImageLoaded(paddleImg);
    } catch (e) {
        console.error('Error loading image', e);
        alert('Failed to load assets');
    }
    draw();
    },
    ensureImageLoaded: async function(img) {
        return new Promise((resolve, reject) => {
            if (img.complete) {
                resolve();
            } else {
                img.onload = resolve;
                img.onerror = reject;
            }
        });
    },
    navigateTo: function(route) {
      this.$router.push(route);
    },
    loadBricks: async function() {
        try {
            const response = await axios.get(this.s3LinkMap);
            this.linkMap = response.data;
        } catch (e) {
            console.error('Error fetching link map', e);
        }
    },
    handleKeyDown(event) {
      // Start movement only if the key isn't already being held down
      if (event.key === 'ArrowLeft' && !this.movingLeft) {
        this.startMovement('left');
      } else if (event.key === 'ArrowRight' && !this.movingRight) {
        this.startMovement('right');
      }
    },
    handleKeyUp(event) {
      if (event.key === 'ArrowLeft') {
        this.stopMovement('left');
      } else if (event.key === 'ArrowRight') {
        this.stopMovement('right');
      }
    },
    startMovement(direction) {
      // Clear any existing interval
      this.stopMovement();

      // Set the movement flags
      if (direction === 'left') {
        this.movingLeft = true;
      } else if (direction === 'right') {
        this.movingRight = true;
      }

      // Start moving with acceleration
      this.movementInterval = setInterval(() => {
        if (direction === 'left') {
          this.moveLeft();
        } else if (direction === 'right') {
          this.moveRight();
        }

        // Increase speed with acceleration but cap it at maxSpeed
        if (this.speed < this.maxSpeed) {
          this.speed += this.acceleration;
        }
      }, 16); // 60 FPS (~16ms per frame)
    },
    stopMovement() {
      clearInterval(this.movementInterval);
      this.speed = 0; // Reset speed when the key is released
      this.movementInterval = null;

      // Reset movement flags
      this.movingLeft = false;
      this.movingRight = false;
    },
    moveLeft() {
      // Move left, reducing the paddle's x position by the current speed
      this.paddle.x -= this.speed;
      if (this.paddle.x < 0) {
        this.paddle.x = 0;
      }
    },
    moveRight() {
      // Move right, increasing the paddle's x position by the current speed
      this.paddle.x += this.speed;
        if (this.paddle.x + this.paddle.width > this.canvas.width) {
            this.paddle.x = this.canvas.width - this.paddle.width;
        }
    },
  },
  mounted: function () {
    this.loadBricks();
    this.loadLeaderboard();
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    this.stopMovement();
  },
  inject: ['updateAppRoute', 'appData', 'postToLambda', 'connectWallet'],
  created: function () {
    this.updateAppRoute('break');
    const isMuted = localStorage.getItem(LOCAL_STORAGE_BREAK_MUTE_KEY);;
    this.isMuted = isMuted === 'true';
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    canvas { background: #eee; display: block; margin: 0 auto; }

    /* Row of 3 justified columns */
    #game-menu { display: flex; justify-content: center; height: 60px; width: 100%;
        background-color: #0063cd !important;
        color: #ffffff;
    }

    /* Row columns */
    #game-menu div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33.3333%;
        height: 100%;
        cursor: pointer;
    }
    #score-label {
        font-family: "DM Sans", sans-serif;
    }
    #game-frame {
        position: relative;
    }
    #game-over {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        min-width: 400px;
        max-width: 800px;
        border-radius: 10px;
        border: 10px solid #002b59;
        padding: 20px;
        margin: 15px auto;
        background-color: #0063cd !important;
        color: #d5d5d5;
    }
</style>



// WEBPACK FOOTER //
// src/components/Break.vue?24413e9e